import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { formatForeignCurrency } from "@common/helpers/currency";
import { getCurrentActivePrice } from "@common/helpers/catalogItemPrice";
import { HStack } from "@design-system/HStack/HStack";
import { Tag } from "@design-system/Tag/Tag";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { CatalogItemRow } from "../catalogItems.types";

export const UnitPriceCell = memo(function UnitPriceCell({
    row,
}: CellContext<ViewTableFeatures, CatalogItemRow, unknown>) {
    const item = row.original;
    const currentPrice = getCurrentActivePrice(item.prices);
    if (item.isNew || !currentPrice) {
        return <ViewTableCell />;
    }

    const formatted = formatForeignCurrency(
        currentPrice.unitAmount,
        currentPrice.currency.toUpperCase(),
    );
    const other = (item.prices ?? []).filter(
        (price) => price.active && price.id !== currentPrice.id,
    );

    return (
        <ViewTableCell>
            <HStack gap={8} align="center">
                {formatted}
                {other.length > 0 && (
                    <Tooltip
                        bullets={other.map((price) =>
                            formatForeignCurrency(
                                price.unitAmount,
                                price.currency.toUpperCase(),
                            ),
                        )}
                    >
                        <span>
                            <Tag size="sm" color="neutral" outline numeric>
                                +{other.length}
                            </Tag>
                        </span>
                    </Tooltip>
                )}
            </HStack>
        </ViewTableCell>
    );
});
